import { ControlType } from '@prguardian/api-types';

export const ulsLevelNames = ['Exception', 'Unexpected', 'Monitorable', 'High', 'Medium'];

/** @returns {import('@prguardian/api-types').UlsEvent[]} */
export function ulsEventsFromControls(controls) {
    return controls.filter(control => control.controlType === ControlType.Uls).map(control => {
        const payload = JSON.parse(control.controlMetadata);
        if (!payload || typeof payload !== 'object' || Array.isArray(payload))
            throw new Error(`Invalid ULS metadata for ${control.controlId}.`);
        const metadata = Object.fromEntries(Object.entries(payload).map(([key, value]) => [key.toLowerCase(), value]));
        if (typeof control.controlId !== 'string' || !control.controlId.trim()
            || !Number.isInteger(metadata.level) || !ulsLevelNames[metadata.level]
            || typeof metadata.introduced !== 'boolean'
            || (metadata.message != null && typeof metadata.message !== 'string')
            || (metadata.sourcefilepath != null && typeof metadata.sourcefilepath !== 'string')
            || (metadata.catchcontext !== undefined && typeof metadata.catchcontext !== 'boolean'))
            throw new Error(`Invalid ULS metadata for ${control.controlId}.`);
        return {
            eventId: control.controlId,
            level: metadata.level,
            introduced: metadata.introduced,
            message: metadata.message ?? null,
            sourceFilePath: metadata.sourcefilepath ?? null,
            catchContext: metadata.catchcontext ?? false,
        };
    });
}

export function ulsHourlyPoints(series) {
    if (!series.length) return [];
    const byHour = new Map(series.map(point => [new Date(point.date).getTime(), point.metricValue]));
    const hours = [...byHour.keys()];
    const start = Math.min(...hours);
    const end = Math.max(...hours);
    const result = [];
    for (let hour = start; hour <= end; hour += 3600000)
        result.push({ x: new Date(hour), y: byHour.get(hour) ?? null });
    return result;
}
